import { useQuery } from '@tanstack/react-query'
import {
  fetchQaFeedbackList,
  fetchQaFeedbackDetail,
  type QaFeedbackListParams,
} from '@/lib/api/admin-qa-feedback'

export const qaFeedbackKeys = {
  all: ['admin-qa-feedback'] as const,
  list: (params: QaFeedbackListParams) => [...qaFeedbackKeys.all, 'list', params] as const,
  detail: (id: string) => [...qaFeedbackKeys.all, 'detail', id] as const,
}

export function useAdminQaFeedbackList(params: QaFeedbackListParams) {
  return useQuery({
    queryKey: qaFeedbackKeys.list(params),
    queryFn: () => fetchQaFeedbackList(params),
  })
}

export function useAdminQaFeedbackDetail(id: string | undefined) {
  return useQuery({
    queryKey: qaFeedbackKeys.detail(id ?? ''),
    queryFn: () => fetchQaFeedbackDetail(id!),
    enabled: !!id,
  })
}
